export const logoutUser = (navigate) => {

  // Clear auth data
  localStorage.removeItem("token");
  localStorage.removeItem("examData");
  localStorage.removeItem("paymentData");
  sessionStorage.removeItem("activeSession");

  // Optional: clear all storage
  localStorage.clear();
  sessionStorage.clear();

  // Redirect to login
  navigate("/login", { replace: true });

};
